<template>
  <div class="relative">
    <div class="line bg-white mt-6 block"></div>
    <div class="yellowline bg-yellow block absolute w-full"></div>
    <div class="max-w-7xl mx-auto pb-6 pt-6">
      <div class="rounded pb-4 relative" id="agenda">
        <div
          class="gradientright bottom-0 right-0 absolute hidden md:block"
        ></div>
        <div class="text-center">
          <AgendaHeader
            day-of-week="Day One"
            day="9"
            class="text-white bg-dakGrey"
            :selected="selectedIndex === 0"
            @click="selectIndexs(0)"
          />
          <AgendaHeader
            day-of-week="Day Two"
            day="10"
            class="text-white bg-dakGrey"
            :selected="selectedIndex === 1"
            @click="selectIndexs(1)"
          />
        </div>
        <p
          class="text-3xl text-darkFont font-bold uppercase text-center mt-1"
        >
          Schedule
        </p>
        <div class="mt-6 flex overflow-x-auto" id="agendas">
          <div class="flex flex-no-wrap">
            <paper-agenda-item
              v-for="session in groupedSessions[selectedSessionKey]"
              :key="session._id"
              :session="session"
            >
            </paper-agenda-item>
            <span class="w-28"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sanityClient } from "../utils/sanity";
import PaperAgendaItem from "./PaperAgendaItem";
import AgendaHeader from "./agenda/AgendaHeader";

export default {
  name: "PaperAgenda",
  components: { AgendaHeader, PaperAgendaItem },
  data() {
    return {
      dates: [],
      groupedSessions: {},
      selectedSessionKey: null,
      selectedIndex: 0
    };
  },
  methods: {
    pollData() {
      this.polling = setInterval(() => {
        this.fetchSessions();
      }, 30000);
    },
    selectIndex(idx) {
      this.selectedIndex = idx;
      this.selectedSessionKey = this.dates[idx];
    },
    selectIndexs(ids) {
      this.selectedIndex = ids;
      this.selectedSessionKey = this.dates[ids];
      document.getElementById("agendas").scroll(0, 0);
    },
    setDate(date) {
      this.selectedSessionKey = date;
    },
    fetchSessions() {
      const queryString =
        "*[_type == 'session'] | order(startTime asc) {speakers[]->{name, portrait, _id},...} | order(startTime asc) {productCompatibility[]->{...}, ...}";
      sanityClient
        .fetch(queryString)
        .then(res => {
          const sessionDates = [];
          const groups = res.reduce((groups, session) => {
            const date = new Date(session.startTime).toLocaleDateString();
            if (!groups[date]) {
              groups[date] = [];
              sessionDates.push(date);
            }
            groups[date].push(session);
            return groups;
          }, {});

          this.dates = sessionDates;
          this.groupedSessions = groups;
          const currentDate = new Date().toLocaleDateString();
          const index = this.dates.findIndex(d => d === currentDate);
          if (index > -1) {
            this.selectIndex(index);
          } else {
            this.selectIndex(this.selectedIndex);
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    }
  },
  mounted() {
    this.fetchSessions();
    this.pollData();
  },
  beforeDestroy() {
    if (this.polling) {
      clearInterval(this.polling);
    }
  }
};
</script>

<style scoped>
.line {
  height: 1px;
  position: relative;
  top: 2.4rem;
}

.bg-darkBlue {
  z-index: 60;
  position: relative;
}

.yellowline {
  height: 1rem;
  top: 19rem;
}

.bg-dakGrey {
  background: #bcbcbc;
}

/* width */
::-webkit-scrollbar {
  height: 6px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #adadad;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #fcc209;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #fcc209;
}

.gradientright {
  background: rgb(188, 188, 188);
  background: -moz-linear-gradient(
    270deg,
    rgba(188,188,188, 1) 0%,
    rgba(188,188,188, 0) 100%
  );
  background: -webkit-linear-gradient(
    270deg,
    rgba(188,188,188, 1) 0%,
    rgba(188,188,188, 0) 100%
  );
  background: linear-gradient(
    270deg,
    rgba(188,188,188, 1) 0%,
    rgba(188,188,188, 0) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#bcbcbc",endColorstr="#adadad",GradientType=1);

  width: 180px;
  z-index: 50;
  height: 90%;
}


/*background: rgb(188,188,188);
background: -moz-linear-gradient(0deg, rgba(188,188,188,1) 0%, rgba(173,173,173,1) 100%);
background: -webkit-linear-gradient(0deg, rgba(188,188,188,1) 0%, rgba(173,173,173,1) 100%);
background: linear-gradient(0deg, rgba(188,188,188,1) 0%, rgba(173,173,173,1) 100%);
filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#bcbcbc",endColorstr="#adadad",GradientType=1);*/

@media only screen and (max-width: 768px) {
  .yellowline {
    top: 17rem;
  }
}
</style>
